import React from "react";
import PropTypes from "prop-types";
import ChimneyProfileTopTenContainer from "./Containers/ChimneyProfileTopTenContainer";

const ProfileTopTen = (props) => (
  <ChimneyProfileTopTenContainer
    chimDir={props.chimDir}
    render={({ topten }) => {
      if (topten.filter((t) => t.item !== "").length === 0) return null;

      return (
        <div className="profile-right-nav profile-top-ten">
          <h3>Top Ten {topten[0].title && <span>"{topten[0].title}"</span>}</h3>
          <ol className="list-flat">
            {topten.map((track, i) => (
              <li key={i}>{track.item}</li>
            ))}
          </ol>
        </div>
      );
    }}
  />
);

ProfileTopTen.propTypes = {
  chimDir: PropTypes.string.isRequired,
};

export default ProfileTopTen;
